// extracted by mini-css-extract-plugin
module.exports = {"popover":"AdaptivePopover_popover__HUxv4"};